import { render } from "./withdraw-detail.vue?vue&type=template&id=432186be&scoped=true"
import script from "./withdraw-detail.vue?vue&type=script&lang=js"
export * from "./withdraw-detail.vue?vue&type=script&lang=js"

import "./withdraw-detail.vue?vue&type=style&index=0&id=432186be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432186be"]])

export default __exports__